import { axiosInstance } from "@/api/axios.instance";
import { IStock } from "@/models";

export const addStock = async (stock: IStock) =>
 await axiosInstance.post(`/stockEntries`, stock);
